import { Component, OnInit } from '@angular/core'
import { NgZorroAntdModule, NzMessageService } from 'ng-zorro-antd'
import { Router, NavigationEnd } from '@angular/router'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { HttpBaseService } from '../services/httpBase.service'
import { HttpServer } from '../services/sie.httpBase'
import api from '../api'
import {
  SetStore,
  GetStore,
  SetSessionStore,
  trimStr
} from '../services/comment'
import { MD5 } from '../services/comment'

// import { getDomain } from "../service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup
  forgetForm: FormGroup
  loginWay: string
  loginTip: string
  nameTip: string
  pwdTip: string
  logoUrl: string
  loginAddress: string
  loginBackground: Object
  isLoginSuccess = false
  redirectUrl: string
  isLoading = false
  codeShow = false
  forgetIsShow = false
  isGetCode = false
  time: number
  codeUrl: string
  forgetPwd: {
    phoneNumber?: string
    code?: string
    pwd?: string
    pwd2?: string
  }
  forgetTip: {
    tip1: string
    tip2: string
    tip3: string
    tip4: string
  }
  emailToken: string

  constructor(
    private fb: FormBuilder,
    private http: HttpBaseService,
    private httpServer: HttpServer,
    private router: Router,
    private msg: NzMessageService
  ) {
    this.loginWay = 'password'
    this.loginTip = ''
    this.nameTip = '请输入用户名'
    this.pwdTip = '请输入密码'
    this.forgetPwd = {}
    this.time = 120
    this.forgetTip = {
      tip1: '请输入手机号',
      tip2: '请输入验证码',
      tip3: '请输入密码',
      tip4: '输入密码不一致'
    }
  }

  ngOnInit() {
    let params = window.location.href
    this.forgetForm = this.fb.group({
      phoneNumber: [
        null,
        [
          Validators.required,
          Validators.maxLength(11),
          Validators.minLength(11)
        ]
      ],
      code: [null, [Validators.required]],
      pwd: [null, [Validators.required]],
      pwd2: [null, [Validators.required]]
    })

    if (GetStore('userInfo')) {
      // this.router.navigate(["main"]);
      let userInfo = JSON.parse(atob(GetStore('userInfo')))
      this.loginForm = this.fb.group({
        userName: [userInfo.userName, [Validators.required]],
        password: [MD5(userInfo.pwd), [Validators.required]],
        remember: [true]
      })
      this.forgetForm.value.userName = userInfo.userName
      this.forgetForm.value.password = MD5(userInfo.pwd)
      this.loginForm.patchValue({
        userName: userInfo.userName,
        password: MD5(userInfo.pwd),
        remember: true
      })
      // this._submitForm();
    } else {
      this.loginForm = this.fb.group({
        userName: [null, [Validators.required]],
        password: [null, [Validators.required]],
        remember: [null]
      })
    }

    params
      .replace('?', '')
      .split('&')
      .map(item => {
        if (/redirectUrl/.test(item)) {
          this.redirectUrl = item.split('=').pop()
        }
        if (/id/.test(item)) {
          this.loginAddress = item.split('=').pop()
        }
      })
    let url = window.location.hostname
    switch (url) {
      case 'e.kabrita.com.cn':
        document.title = '木易网管理平台'

        this.logoUrl = 'assets/images/au7/logo.png'
        this.loginBackground = {
          background: "url('assets/images/au7/back.jpg' ) no-repeat",
          'background-size': 'cover'
        }
        break
      default:
        document.title = '木易网管理平台'
        this.logoUrl = 'assets/images/au7/logo.png'
        this.loginBackground = {
          background: "url('assets/images/au7/back.jpg' ) no-repeat",
          'background-size': 'cover'
        }
        break
    }
    // this.http
    //   .post(api.getQrCodeUrl, {
    //     params: JSON.stringify({ domain_like: window.location.hostname })
    //   })
    //   .subscribe(res => {
    //     this.codeUrl = res.data
    //     console.log(this.codeUrl)
    //   })
  }

  _submitForm() {
    if (!GetStore('userInfo')) {
      for (const i in this.loginForm.controls) {
        this.loginForm.controls[i].markAsDirty()
      }
    }
    let host = window.location.host
    host =
      host.indexOf(':') !== -1 ? host.substring(0, host.indexOf(':')) : host
    host = window.location.protocol + '//' + host
    /*     host = 'https://192.168.21.116'; //  测试本地 获取能力多的图片数据
    alert('login.component.ts 第190 行使用了测试数据，记得删除'); */
    let userInfo = {
      userName: trimStr(this.loginForm.value.userName),
      pwd: MD5(this.loginForm.value.password),
      redirectUrl: this.redirectUrl,
      domain: host
    }
    if (this.loginForm.valid === true) {
      this.isLoading = true
      this.http
        .login(api.login, {
          params: JSON.stringify(userInfo)
        })
        .then(res => {
          this.isLoading = false

          if (res.status !== 'E') {
            // GlobalVariable.pwdStatus = res.status;

            SetSessionStore('pwdStatus', res.status)

            let data = res.data
            // if (data.userHeadImgUrl) {
            //   data.userHeadImgUrl = data.userHeadImgUrl.replace(
            //     /http:|https:/im,
            //     ''
            //   )
            // }
            if (!data.accessPath) {
              data['accessPath'] = ''
            }

            localStorage.successLoginInfo = sessionStorage.successLoginInfo = JSON.stringify(
              data
            )

            SetStore('lastUserName', data.userName)
            SetSessionStore('certificate', res.data.certificate)
            SetSessionStore('languageList', res.data.languageList)

            if (this.loginForm.value.remember === true) {
              SetStore('userInfo', btoa(JSON.stringify(userInfo)))
            } else {
              localStorage.removeItem('userInfo')
            }

            if (res.data.redirectUrl !== undefined) {
              window.location.href = res.data.redirectUrl
            } else {
              this.router.navigate(['main'])
            }
          } else {
            this.isLoginSuccess = true
            this.loginTip = res.msg
          }
        })
    }
  }
  recordPassword() {}
  _code(way) {
    this.codeShow = true
    ;(<HTMLInputElement>document.getElementById('code')).src = `${
      this.codeUrl
    }&n=${Math.random()}`
  }
  forget() {
    this.forgetIsShow = true
    this.forgetPwd = {}
    this.forgetForm.reset()
  }
  closeCode() {
    this.codeShow = !this.codeShow
  }
  Cancel() {
    this.forgetIsShow = false
  }

  getCode() {
    if (!this.forgetForm.value.phoneNumber) {
      this.forgetForm.controls.phoneNumber.markAsDirty()
    } else {
      this.http
        .post(api.getCheckCode, {
          params: JSON.stringify({
            phoneNumber: this.forgetForm.value.phoneNumber
          })
        })
        .subscribe(res => {
          this.time = 120
          if (res.status === 'S') {
            this.isGetCode = !this.isGetCode
            let timer = setInterval(() => {
              this.time--
              if (this.time === 0) {
                clearInterval(timer)
                this.isGetCode = !this.isGetCode
              }
            }, 1000)
          } else {
            // this.forgetForm.controls.phoneNumber.markAsPristine();
            this.msg.error(res.msg)
          }
        })
    }
  }
  _saveForget() {
    for (const i in this.forgetForm.controls) {
      this.forgetForm.controls[i].markAsDirty()
    }
    if (this.forgetForm.value.pwd !== this.forgetForm.value.pwd2) {
      this.msg.warning('两次密码不一致')
      return
    }
    if (this.forgetForm.valid === true) {
      this.http
        .post(api.passwordReminder, {
          params: JSON.stringify({
            phoneNumber: this.forgetForm.value.phoneNumber,
            code: this.forgetForm.value.code,
            pwd: MD5(this.forgetForm.value.pwd)
          })
        })
        .subscribe(res => {
          if (res.status === 'S') {
            this.msg.success(res.msg)
            this.forgetIsShow = false
          } else {
            this.msg.error(res.msg)
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/login/login.component.ts